<template>
  <a-modal
    :title="title"
    :width="700"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="mode === 'view' ? '关 闭' : '取 消'"
    :okText="mode === 'view' ? '确 定' : '确认完成'"
    destroyOnClose
  >
    <a-spin :spinning="confirmLoading">
      <a-form :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-form-item label="所属日程" v-if="planTitle">
          <a-input :value="planTitle" disabled />
        </a-form-item>

        <a-form-item label="计划项目">
          <a-input :value="detail.title_dictText || detail.title || '-'" disabled />
        </a-form-item>

        <template v-if="mode === 'view'">
          <a-form-item label="完成人">
            <a-input :value="detail.completedUserName || '-'" disabled />
          </a-form-item>
          <a-form-item label="完成时间">
            <a-input :value="detail.completedTime || '-'" disabled />
          </a-form-item>
        </template>

        <a-form-item label="完成说明">
          <a-textarea
            v-model="form.remark"
            :disabled="mode === 'view'"
            :placeholder="mode === 'view' ? '暂无说明' : '请输入现场处理情况、核查比对结果等说明...'"
            :autoSize="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>

        <a-form-item label="现场凭证">
          <iws-upload
            ref="detailUpload"
            filesrc="om_work_plan_detail"
            :srcid="detail.id || 0"
            :disableSubmit="mode === 'view'"
            :options="{ btnText: '上传现场凭证' }"
          ></iws-upload>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import IwsUpload from '@comp/upload/IwsUpload'
import { completeWorkPlanDetail } from '@/api/api'

export default {
  name: 'WorkPlanDetailCompleteModal',
  components: {
    IwsUpload
  },
  data() {
    return {
      title: '完成计划项目',
      visible: false,
      mode: 'complete', // 'complete' 或 'view'
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      planTitle: '',
      detail: {},
      form: {
        remark: ''
      }
    }
  },
  methods: {
    complete(record, planTitle) {
      this.mode = 'complete'
      this.title = '完成计划项目'
      this.planTitle = planTitle || ''
      this.detail = Object.assign({}, record)
      this.form.remark = record.remark || ''
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.detailUpload && typeof this.$refs.detailUpload.loadUploadFiles === 'function') {
          this.$refs.detailUpload.loadUploadFiles('om_work_plan_detail', this.detail.id)
        }
      })
    },
    view(record, planTitle) {
      this.mode = 'view'
      this.title = '计划项目执行凭证'
      this.planTitle = planTitle || ''
      this.detail = Object.assign({}, record)
      this.form.remark = record.remark || ''
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.detailUpload && typeof this.$refs.detailUpload.loadUploadFiles === 'function') {
          this.$refs.detailUpload.loadUploadFiles('om_work_plan_detail', this.detail.id)
        }
      })
    },
    handleOk() {
      if (this.mode === 'view') {
        this.close()
        return
      }
      this.confirmLoading = true
      let postData = {
        detailId: this.detail.id,
        remark: this.form.remark
      }
      if (this.$refs.detailUpload && typeof this.$refs.detailUpload.getUploadListToFromData === 'function') {
        postData = this.$refs.detailUpload.getUploadListToFromData(postData)
      }

      completeWorkPlanDetail(postData)
        .then(res => {
          if (res && res.success) {
            this.$message.success(res.message || '操作成功！')
            this.$emit('ok')
            this.close()
          } else {
            this.$message.warning((res && res.message) || '操作失败！')
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || '网络异常，提交失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.visible = false
      this.detail = {}
      this.form.remark = ''
      this.planTitle = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style scoped>
</style>
